export default "__VITE_ASSET__D$D1uMLF__"